export class BaseSheet {
  sheet_code: string
  grade: number
  curriculum_id: number
  level: string
  month: number
  name: string
  page_count: number
  
  constructor(base_sheet: any){
    this.sheet_code = base_sheet.sheet_code;
    this.grade = base_sheet.grade;
    this.curriculum_id = base_sheet.curriculum_id;
    this.level = base_sheet.level;
    this.month = base_sheet.month;
    this.name = base_sheet.name;
    this.page_count = base_sheet.page_count;
  }
}

export class Daimon {
  daimon_no: string
  angle: number = 0
  baseWidth: number = 0
  baseHeight: number = 0
  base64Image: string
  registed: boolean = false

  constructor(daimon: any){
    this.daimon_no = daimon.daimon_no;
    this.baseWidth = daimon.width;
    this.baseHeight = daimon.height;
    this.base64Image = daimon.base64Image;
    this.registed = daimon.registed;
  }
}
